import { BlgBadge } from './Badge';

export default BlgBadge;
